import { routerStyxie } from '@/router/styxieBridge'

Styxie.Initializers.GoogleAccounts = routerStyxie({ actions: ['index', 'show']})
